import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { LayoutConfig } from '@layout/layout.abstract.config';

@Injectable({
  providedIn: 'root',
})
export class IsMobileViewService {
  constructor(
    private breakpointObserver: BreakpointObserver,
    private layoutConfig: LayoutConfig,
  ) {
  }

  isMobileView$(): Observable<boolean> {
     return this.breakpointObserver.observe(
      `(max-width: ${this.layoutConfig.breakpoints.sm})`,
    ).pipe(
      map(({ matches }) => matches),
      shareReplay(1)
    );
  }
}
